import * as React from 'react';
import { observer } from 'mobx-react-lite';
import { CustomCheckboxWrapper } from '../../components';
import { CustomFormItem } from '../../../custom_shared/components';
import { InputModel } from '../../models';
import { InputWithMeta } from '../../componentTypes';

// Please note that this is a generic component if behavior for your input is different - create a new independent component (like BusinessTypeInput.tsx etc.)

interface Props {
    label: string;
    input: InputModel;
    disabled?: boolean;
}

const GenericCheckbox: InputWithMeta<Props> = ({ label, input, disabled }) => (
    <CustomFormItem name={input.guid} valuePropName="checked" isReadOnly={input.isReadOnly}>
        <CustomCheckboxWrapper label={label} input={input} disabled={disabled} />
    </CustomFormItem>
);

GenericCheckbox.meta = {
    inputType: InputModel.name
};

export default observer(GenericCheckbox);
